<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  name: 'ChartsPie',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      const mychart = echarts.init(this.$refs.mychart)
      let legendData = []
      if (this.data) {
        legendData = this.data.map((item) => item.name)
      }
      const option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // 图例说明
        legend: {
          show: true,
          // orient: 'vertical',
          // left: 24,
          x: 'center',
          // width: 400,
          top: 'bottom',
          itemWidth: 12,
          itemHeight: 10,
          itemGap: 5,
          data: legendData,
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            color: '#aaa',
            rich: {
              a: {
                width: 110,
                fontSize: 10,
                lineHeight: 12
                // backgroundColor: 'transparent'
              }
            }
          }
        },
        // 颜色配置
        color: [
          '#667eea',
          '#19be6b',
          '#ff9a9e',
          '#fbc2eb',
          '#96e6a1',
          '#d4fc79',
          '#84fab0',
          '#8fd3f4',
          '#fccb90',
          '#d57eeb',
          '#e0c3fc',
          '#cfd9df'
        ],
        // 类型配置
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  fontSize: 14,
                  formatter: '{c} ({d}%)'
                },
                labelLine: {
                  show: true
                }
              }
            },
            name: '设备类型',
            // 类型配置
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['50%', '45%'],
            // 数据配置
            data: this.data
          }
        ]
      }
      mychart.setOption(option)
      // window.addEventListener('resize', this.resize)
    }
  }
}
</script>
